/**
 * @category Helper
 */
function isInputElement(el) {
    var _a;
    return ((_a = el) === null || _a === void 0 ? void 0 : _a.nodeName) === 'INPUT';
}
/**
 * @category Helper
 */
function isTextAreaElement(el) {
    var _a;
    return ((_a = el) === null || _a === void 0 ? void 0 : _a.nodeName) === 'TEXTAREA';
}
/**
 * @category Helper
 */
function isSelectElement(el) {
    var _a;
    return ((_a = el) === null || _a === void 0 ? void 0 : _a.nodeName) === 'SELECT';
}
/**
 * @category Helper
 */
function isFieldSetElement(el) {
    var _a;
    return ((_a = el) === null || _a === void 0 ? void 0 : _a.nodeName) === 'FIELDSET';
}
/**
 * @category Helper
 */
function isFormControl(el) {
    return isInputElement(el) || isTextAreaElement(el) || isSelectElement(el);
}
/**
 * @category Helper
 */
function isElement(el) {
    return el.nodeType === Node.ELEMENT_NODE;
}

export { isElement, isFieldSetElement, isFormControl, isInputElement, isSelectElement, isTextAreaElement };
//# sourceMappingURL=typeGuards.js.map
